





















































































































































































































import { PopRoute, AddRoute, ReplaceRoute } from '../../types/store';
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import AdminPageInfo from './AdminPageInfo.vue';
import AdminCard from './AdminCard.vue';
import btn from './btn.vue';
import Label from './Label.vue';

@Component({
    components: {
        AdminPageInfo,
        AdminCard,
        btn,
        Label,
    },
})
export default class Payment extends Vue {
    @State adminUser: string;
    @State routes: string[];
    @State selection: string;
    @Mutation popRoute: PopRoute;
    @Mutation replaceRoute: ReplaceRoute;
    @Mutation changeSelection: (value: string) => void;
    @Mutation setPage: Function;
    creditCard: string = '';

    get Selection(): string {
        return this.selection;
    }

    set Selection(value: string) {
        this.changeSelection(value);
    }

    mounted(): void {
        this.replaceRoute(['Booking', 'Reserve', 'Create Package', 'Information', 'Overview']);
        let date = new Date();
      this.setPage(4);
    }
    /**
     *
     */
    constructor() {
        super();
    }

    beforeDestroy(): void {
        this.popRoute();
    }
}
